export const LOYALTY_REWARDS_POINTS_TEXT_ID = 'pointsApplied';
export const SHOW_REWARDS_LOGO = false;
export const POINTS_TRANSLATION_KEY = 'points';
export const LOYALTY_POINTS_ICON_COLOR = '#FFAA00';
